var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 4h-10a2.5 2.5 0 0 0 -2.5 2.5v1a.5.5 0 0 0 1 0v-1a1.5 1.5 0 0 1 1.5-1.5h4.5v15h-4.5a1.5 1.5 0 0 1 -1.5-1.5v-1a.5.5 0 0 0 -1 0v1a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5v-12a2.5 2.5 0 0 0 -2.5-2.5zm1.5 14.5a1.5 1.5 0 0 1 -1.5 1.5h-4.5v-15h4.5a1.5 1.5 0 0 1 1.5 1.5zm-13-8v1.5h1.5a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1 -1 0v-1.5h-1.5a.5.5 0 0 1 0-1h1.5v-1.5a.5.5 0 0 1 1 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns2);
export default __webpack_public_path__ + "static/media/columns (2).f8efa66171ab3d3e9c60bbd315b87dab.svg";
export { ForwardRef as ReactComponent };